import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, we are  <span className="purple">Geidam IT SOlution </span>
            from <span className="purple"> Yobe State , Nigeria .</span>
            <br /> 
            <ul>
  <li className="about-activity"><ImPointRight />
      Our technical community is a platform that offers comprehensive training, resources, and support for individuals and teams 
    involved in software development, building and installation processes, and business concepts.</li>
    
<li className="about-activity"><ImPointRight />
  Training: We provide a wide range of training programs and workshops designed to enhance your technical skills and knowledge. Whether you're a beginner or an experienced professional, our training courses cover various programming languages, frameworks,
    tools, and methodologies to help you stay up to date with the latest industry trends.</li>
  
   <li className="about-activity"> <ImPointRight />
     Building and Software Installation/Development: Our platform offers guidance and best
     practices for building and installing software applications. We provide step-by-step tutorials, documentation, and troubleshooting tips to assist you in developing high-quality software solutions. From project setup and configuration to deployment and maintenance, we cover the entire software development lifecycle.</li>

<li className="about-activity"> <ImPointRight />
    Business Concept Site: We understand that software development is not just about coding.
    Our platform also focuses on the business side of software development. We provide insights into business concepts, including project management, product development, marketing strategies, customer engagement, and monetization models. We aim to help you understand the broader aspects of software development and how it aligns with your business objectives.
    </li>            
    </ul> 
     </p>
 

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Alanjiro JIbreen </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
